import React, { useState } from "react";
import {
  signInWithPopup,
  GoogleAuthProvider,
  getAuth,
  signOut,
} from "firebase/auth";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import GoogleIcon from "@mui/icons-material/Google";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { authentication } from "./firebase-config.js";
import {
  useMenu,
  useMenuUpdate,
  usePush,
  usePushUpdate,
  useUserEmail,
  useUserEmailUpdate,
  useUserName,
  useUserNameUpdate,
} from "./Store.js";

export default function Menu() {
  const menu = useMenu();
  const setMenu = useMenuUpdate();
  const [avtURL, setAvtURL] = useState("");
  const userName = useUserName();
  const setUserName = useUserNameUpdate();
  const userEmail = useUserEmail();
  const setUserEmail = useUserEmailUpdate();
  const isPush = usePush();
  const setPush = usePushUpdate();

  const handleChange = (event) => {
    setPush(event.target.checked);
  };

  const logInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(authentication, provider)
      .then((re) => {
        const user = re.user;

        setAvtURL(user.photoURL);
        setUserName(user.displayName);
        setUserEmail(user.email);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const logOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        console.log("Log out successful");
        setAvtURL("");
        setUserName("");
        setUserEmail("");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Drawer anchor="left" open={menu} onClose={setMenu}>
        <Box sx={{ width: 266, height: 64, bgcolor: "#a2a8d3" }}>
          <Typography
            variant="h4"
            sx={{
              display: "flex",
              justifyContent: "center",
              p: 1,
            }}
          >
            Settings
          </Typography>
        </Box>

        {userName ? (
          <Box
            sx={{
              width: 250,
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              p: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                pb: 1,
                alignItems: "center",
              }}
            >
              <Avatar alt={userName} src={avtURL} />
              <Typography variant="h5" sx={{ p: 1 }}>
                {userName}
              </Typography>
            </Box>
            <Typography variant="caption" sx={{ lineHeight: 1, p: 1 }}>
              Fall notification will be send to {userEmail}
            </Typography>
            <Button variant="contained" onClick={logOut} color="error">
              Sign out
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              width: 250,
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              p: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{ display: "block", justifyContent: "center", p: 1 }}
            >
              Sign in with Google to enable email notification.
            </Typography>
            <Button
              variant="outlined"
              startIcon={<GoogleIcon />}
              onClick={logInWithGoogle}
              sx={{ p: 1 }}
            >
              Sign in with Google
            </Button>
          </Box>
        )}

        <Divider />
        <Box
          sx={{
            width: 250,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 1,
          }}
        >
          <Typography variant="caption" sx={{ p: 1 }}>
            Receive push notifications.
          </Typography>
          <Switch
            checked={isPush}
            onChange={handleChange}
            size="small"
            inputProps={{ "aria-label": "controlled" }}
          />
        </Box>
        <Divider />
      </Drawer>
    </>
  );
}
